import { ICategoryMenuActions } from "../../action-types/category/ICategoryMenuActionType";
import { ICategoryMenuReducer } from "../../reducer-model/category/ICategoryMenuReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: ICategoryMenuReducer = {
    status: eReducerStatusBase.is_not_initialization,
    categoryMenus: []
}
export const categoryMenuReducer = (state: ICategoryMenuReducer = iniState, action: ICategoryMenuActions): ICategoryMenuReducer => {
    switch (action.type) {
        case "CATEGORY_MENU_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "CATEGORY_MENU_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                categoryMenus: action.payload
            }
        case "CATEGORY_MENU_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CATEGORY_MENU_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                categoryMenuEditing: action.payload
            }
        case "CATEGORY_MENU_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CATEGORY_MENU_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "CATEGORY_MENU_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "CATEGORY_MENU_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "CATEGORY_MENU_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "CATEGORY_MENU_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "CATEGORY_MENU_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}

